import React, { Fragment, Component } from "react";
import SiteHeader from "./Header";
import SiteFooter from "./Footer";
import SubHeader from "./SubHeader";
import UserPageActions from "./UserPageActions";
import UserGridActions from "./UserGridActions";
import UserPageLayout from "../../Pages/Users";
import BulkEditPageLayout from "../../Pages/Users/bulkEdit";
import { connect } from "react-redux";
import { Dimmer, Modal, Loader, Grid, Icon, Button } from "semantic-ui-react";
import * as actions from "../../actions/users/getUserActions";
import moment from "moment";
import { bindActionCreators } from "redux";
import { createNotification, NOTIFICATION_TYPE_SUCCESS } from 'react-redux-notify';

class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectCount: 0,
            exportTOExcel: 0,
            subHeaderItems: [
                {
                    name: "Manage Users",
                    url: ""
                },
                {
                    name: "Staff Manager",
                    url: "oip://staff/staffmanager"
                }
            ],

            helpMenuItems: [
                //{
                //    name: "Help",
                //    url: "Help URL",
                //    position: "bottom left"
                //},
                //{
                //    name: "Video",
                //    url: "Video URL",
                //    position: "bottom center"
                //},
                //{
                //    name: "User Guide",
                //    url: "xcmhelp/help/index.html#!Documents/manageusers.htm",
                //    position: "bottom right"
                //},
            ]
        };
    }

    toggleBulkEditForm() {
        this.setState({
            shouldModalOpen: !this.state.shouldModalOpen
        });
    }

    render() {
        let len = this.props.selectedUsers.selectedUsersIds;
        let firmInteration = this.props.lookupData.FirmLinkage;

        if (firmInteration != undefined && !firmInteration) {
            this.state.subHeaderItems = this.state.subHeaderItems.filter(function (item) {
                return item.name != "Staff Manager";
            }).map(function ({ name, url }) {
                return { name, url };
            });
        }

        return (
            <Fragment>
                {/* <SiteHeader /> */}
                <SubHeader subHeaderMenuItems={this.state.subHeaderItems} helpMenuItems={this.state.helpMenuItems} showClose={false} />
                <UserPageActions
                    reqClass={len.length ? "data_header--with_action" : "data_header"}
                />
                {len.length ? (
                    <UserGridActions
                        toggleBulkEditForm={this.toggleBulkEditForm.bind(this)}
                    />
                ) : (
                        ""
                    )}
                <UserPageLayout />
                {/* <SiteFooter /> */}
                <BulkEditPageLayout
                    shouldModalOpen={this.state.shouldModalOpen}
                    toggleBulkEditForm={this.toggleBulkEditForm.bind(this)}
                />


            </Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
        selectedUsers: state.userReducer.selectedUsers,
        isModalOpen: state.userReducer.isModalOpen,
        allUsers: state.userReducer.allUsers,
        lookupData: state.userReducer.lookupData
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
    createNotification: (config) => {
        dispatch(createNotification(config))
    },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Layout);

//export default Layout;
